// MyContext.js
import React, { createContext, useRef, useContext, useState,useEffect } from 'react';

const MyContext = createContext();

export const MyProvider = ({ children }) => {
  const [functionCalled, setFunctionCalled] = useState(false);
  const [targetId, setTargetId] = useState(null);


  useEffect(()=>{console.log(targetId,functionCalled);},[targetId,functionCalled])

  const myRef = useRef(null);
  const callFunction = (id) => {
    setTargetId(id);
    setFunctionCalled(true);
    setTimeout(() => {
      setFunctionCalled(false);
      setTargetId(null);
    }, 1000); // 300ms = 0.3s
  };
  return (
    <MyContext.Provider value={{ myRef, callFunction, functionCalled, targetId }}>
      {children}
    </MyContext.Provider>
  );
};

export const useMyContext = () => useContext(MyContext);
